// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"094762e0","732":"5270a4f3","977":"14a6c339"}[chunkId] + ".chunk.js";
};